<template>
  <base-card
    v-if="EntityCardMixin_CopySource"
    :title="EntityCardMixin_Title"
  >
    <v-row>
      <base-field
        v-if="EntityCardMixin_CopySource.description"
        v-model="EntityCardMixin_CopySource.description"
        base-field-container-type="v-col"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('description')"
        :readonly="EntityCardMixin_Readonly"
        :rules="[validationMixin.rules.required, validationMixin.rules.charactersMax(EntityCardMixin_CopySource.description.value, 255)]"
      />
      <base-field
        v-if="EntityCardMixin_CopySource.userType"
        v-model="EntityCardMixin_CopySource.userType"
        base-field-container-type="v-col"
        base-field-type="autocomplete"
        :disabled="EntityCardMixin_Disabled"
        :items="userTypes"
        :label="TextMixin_GetLabel('userType')"
        :readonly="EntityCardMixin_Readonly"
        :rules="[validationMixin.rules.required]"
      />
    </v-row>
  </base-card>
</template>

<script>
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardUserManagementRolesDetailGeneralInformation',
  mixins: [
    EntityCardMixin
  ],
  mounted () {
    this.Initialize()
  },
  methods: {
    Initialize () {
      this.EntityCardMixin_SetDefaultTitle('generalInformation')
    }
  }
}
</script>
